import React, {useState, useEffect} from "react";
import classes from "./qrpage.module.css";
import VerifyIcon from "../../assets/qr_product_verify_icon.svg";
import {IoArrowForwardSharp} from "react-icons/io5";
import Document from "../../assets/document.svg";
import VideoLogo from "../../assets/video.svg";
import VerifyMiniLogo from "../../assets/verify.svg";
import WhatsAppLogo from "../../assets/whatsapp_logo.svg";
import TrackLogo from "../../assets/track.svg";
import MedBox from "../../assets/medicine_box.svg";
import useProductData from "../../CustomHooks/useProductData";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";
import {Button, Modal} from "@mui/material";
import ComingSoon from "../Home/ComingSoon";
import {PDFViewer} from "./PDFViewer";
import {IoCloseSharp} from "react-icons/io5";
import ReactPlayer from "react-player";
import VerifyBatch from "./VerifyBatch";
import HomeScreen from "./whatsAppScreens/HomeScreen";

const Product = () => {
  const gmpLink = "https://s3.ap-south-1.amazonaws.com/data.eurocross.in/EU+GMP+Akums+Plant+1.pdf";
  const trackDosage = "https://s3.ap-south-1.amazonaws.com/data.eurocross.in/Eurocross-patient-friendly.pdf";
  const productDetailsBaseURL = "https://s3.ap-south-1.amazonaws.com/data.eurocross.in/ProductDetails/";
  const navigate = useNavigate();
  const {productName} = useParams();
  const {data, loading, error} = useProductData(productName);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 500);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [pdfModal, setShowPdfModal] = useState({show: false, url: "", title: ""});
  const [showPlantVideo, setShowPlantVideo] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 500);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const downloadPDF = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (data && !data?.length) {
      navigate("/");
    }
  }, [data]);

  return (
    <div className={classes.qrProductPage}>
      <div className={classes.qr_page_section_1}>
        <div>
          <div>
            <div className={classes.verifyMiniView}>
              <img src={VerifyMiniLogo} alt="verify logo" />
              <div>
                <p>Verify the quality</p>
                <div>
                  Thank you for scanning <strong>{data?.[0]?.name}</strong> QR code. Please check the lab reports below.
                </div>
                <br />
              </div>
            </div>
            <Button onClick={() => setShowVerifyModal(true)} disabled={loading || error} variant="contained" className={`${classes.verify_button} ${loading ? classes.shimmer : ""}`}>
              {loading ? (
                "Loading..."
              ) : (
                <>
                  View lab report &nbsp; <IoArrowForwardSharp />
                </>
              )}
            </Button>
          </div>
          <div>
            <img src={VerifyIcon} alt="Verify Icon" />
          </div>
        </div>
        <div>
          <div className={classes.gmpDiv} onClick={() => setShowPdfModal({show: true, url: gmpLink, title: "EU-GMP Certificate"})}>
            <div>
              <img src={Document} alt="Document" />
            </div>
            <div>
              View EU-GMP
              <br />
              Certificate
            </div>
          </div>

          <div onClick={() => setShowPlantVideo(true)} className={classes.plantVideoDiv}>
            <div>
              <img src={VideoLogo} alt="Video" />
            </div>
            <div>
              View Plant
              <br />
              Video
            </div>
          </div>
        </div>
      </div>

      <div className={classes.whatsappDiv}>
        <div>
          <div className={classes.whatsAppDivheader}>Track your dosage</div>
          <div className={classes.whatsappDivheaderBorder}></div>
        </div>
        <div className={`${classes.qr_page_section_2}`}>
          <div>
            <div>
              <div className={classes.whatsAppReminderMiniView}>
                <img src={WhatsAppLogo} alt="WhatsApp logo" />
                <p>
                  WhatsApp
                  <br />
                  Reminder
                </p>
              </div>
              {isSmallScreen && <div style={{fontSize: "14px"}}>Set-up your own healthcare assistant to get timely reminders for taking medicine</div>}

              <Button onClick={() => setShowWhatsAppModal(true)} disabled={loading || error} variant="contained" className={`${classes.wtsapp_reminder_button} ${loading ? classes.shimmer : ""}`}>
                {loading ? (
                  "Loading..."
                ) : (
                  <>
                    {isSmallScreen ? "Set-up Now" : "Set-up your Healthcare assistant"}
                    &nbsp; <IoArrowForwardSharp />
                  </>
                )}
              </Button>
            </div>
            <div>
              <img src={WhatsAppLogo} alt="WhatsApp Icon" />
            </div>
          </div>
          <div>
            <div onClick={() => setShowPdfModal({show: true, url: trackDosage, title: "Track your dosage"})} className={classes.dosageDiv}>
              <div>
                <img src={TrackLogo} alt="Document" />
              </div>
              <div>
                Track&nbsp;your
                <br />
                dosage
              </div>
            </div>

            <div
              className={classes.medDetailsDiv}
              onClick={() => {
                if (!data[0]?.productDetailsLink) return;
                setShowPdfModal({show: true, url: productDetailsBaseURL + data[0]?.productDetailsLink, title: "Medicine Details"});
              }}>
              <div>
                <img src={MedBox} alt="Medicine Details Logo" />
              </div>
              <div>
                Explore
                <br />
                medicine&nbsp;details
              </div>
            </div>
          </div>
        </div>
      </div>

      {showVerifyModal &&
        (data?.[0]?.batches?.length ? (
          <Modal className={classes.productModal} open={showVerifyModal} onClose={() => setShowVerifyModal(false)}>
            <VerifyBatch productDetails={data?.[0]} closeModal={() => setShowVerifyModal(false)} />
          </Modal>
        ) : (
          <Modal className={classes.productModal} open={showVerifyModal} onClose={() => setShowVerifyModal(false)}>
            <div className={classes.comingSoonDiv}>
              <ComingSoon />
            </div>
          </Modal>
        ))}

      {showComingSoon && (
        <Modal className={classes.productModal} open={showComingSoon} onClose={() => setShowComingSoon(false)}>
          <div className={classes.comingSoonDiv}>
            <ComingSoon />
          </div>
        </Modal>
      )}

      {showPlantVideo && (
        <Modal className={classes.productModal} open={showPlantVideo} onClose={() => setShowPlantVideo(false)}>
          <div className={classes.plantVideoModal}>
            <div className={classes.pdfModalHeader}>
              <div>Plant Video</div>
              <div>
                <IoCloseSharp onClick={() => setShowPlantVideo(false)} />
              </div>
            </div>
            <ReactPlayer width="90%" height="90%" style={{margin: "0px auto"}} controls={true} url="https://s3.ap-south-1.amazonaws.com/data.eurocross.in/Plant%20video.mp4" />
          </div>
        </Modal>
      )}

      {pdfModal.show && (
        <Modal className={classes.pdfModal} open={pdfModal.show} onClose={() => setShowPdfModal({show: false, url: "", title: ""})}>
          <div className={classes.pdfModalDiv}>
            <div>
              <div className={classes.pdfModalHeader}>
                <div>{pdfModal.title}</div>
                <div>
                  <IoCloseSharp onClick={() => setShowPdfModal({show: false, url: "", title: ""})} />
                </div>
              </div>
              <PDFViewer url={pdfModal.url} />
            </div>

            <div
              className={classes.pdfModalDownloadDiv}
              onClick={() =>
                downloadPDF(
                  pdfModal.url,
                  `${productName}.pdf
            `
                )
              }>
              <Button>Download</Button>
            </div>
          </div>
        </Modal>
      )}

      {showWhatsAppModal && (
        <Modal className={classes.productModal} open={showWhatsAppModal} onClose={() => setShowWhatsAppModal(false)}>
          <HomeScreen productID={productName} productName={data?.[0]?.name} closeModal={() => setShowWhatsAppModal(false)} />
        </Modal>
      )}
    </div>
  );
};

export default Product;
